import { render } from "./RepairReviewInformation.vue?vue&type=template&id=f572a416&scoped=true&ts=true"
import script from "./RepairReviewInformation.vue?vue&type=script&lang=ts"
export * from "./RepairReviewInformation.vue?vue&type=script&lang=ts"

import "./RepairReviewInformation.vue?vue&type=style&index=0&id=f572a416&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f572a416"]])

export default __exports__